export default class Reading {

	constructor (data) {
		if (data) {
			this.id = parseInt(data.id)
			this.datetime = data.reading_time
			this.type = data.type
			this.type_id = data.type_id
			this.values = data.values
		} else {
			this.datetime = ''
			this.type = ''
			this.type_id = ''
			this.values = {}
		}
	}
}



// WEBPACK FOOTER //
// ./src/classes/Reading.js